import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import {
  Paper,
  Container,
  Box,
  MaterialUICore,
  Typography,
} from '@iclinic/design-system';
import useStyles from './Header.style';
import {
  patientInfoSelector,
  patientHistorySelector,
} from '../state/selectors';
import { HeaderCard } from './HeaderCard';
import { HeaderDialog } from './HeaderDialog';

const { Avatar } = MaterialUICore;

function Header(): JSX.Element {
  const classes = useStyles();

  const patientInformation = useSelector(patientInfoSelector);
  const sections = useSelector(patientHistorySelector);

  const [modalContent, setModalContent] = useState({
    title: '',
    observation: '',
    id: '',
  });
  const [renderDialog, setRenderDialog] = useState(false);

  const renderSection = (section: typeof sections[number]) => {
    const handleClick = () => {
      const { title, observation, id } = section;
      setModalContent({ title, observation, id });
      setRenderDialog(true);
    };

    return (
      <HeaderCard onClick={handleClick} section={section} key={section.id} />
    );
  };

  const handleClose = () => setRenderDialog(false);

  return (
    <Container className={classes.header}>
      <Paper
        className={classes.patient}
        elevation={0}
        title="Informação do paciente"
      >
        <Box display="flex" alignItems="center" data-testid="patient-header">
          <Avatar
            alt={patientInformation?.name}
            src={patientInformation?.picture}
            className={classes.avatar}
          />
          <Box ml={2}>
            <Typography className={classes.name} variant="body2">
              {patientInformation?.name}
            </Typography>
            <Typography className={classes.info}>
              {patientInformation.infoText}
            </Typography>
          </Box>
        </Box>
      </Paper>
      <Box className={classes.containerCard}>
        {sections && sections.map(renderSection)}
      </Box>
      {renderDialog && (
        <HeaderDialog
          open={renderDialog}
          title={modalContent.title}
          observation={modalContent.observation}
          onClose={handleClose}
        />
      )}
    </Container>
  );
}

export default Header;
